<!-- Modal Import / export planning -->
<template>
<div class="card modal-card">
    <header class="card-header modal-card-header-title">
        <div class="card-header-title modal-card-header-title">
            <p class="card-title modal-card-title">{{$t('ImportPlanningModal.title')}}</p>
        </div>
        <a @click="$parent.close()" class="card-header-icon" aria-label="more options">
            <b-icon icon="close" type="is-white"></b-icon>
        </a>
    </header>
    <section class="card-content">

        <b-tabs>
            <b-tab-item >
                <template slot="header">
                    <b-icon icon="file-import"></b-icon>
                    <span> {{$t('ImportPlanningModal.tab_import')}} </span>
                </template>

                <b-field :label="$t('ImportPlanningModal.input_planning')">
                    <b-input v-model="planningData" type="textarea" rows="1" placeholder="CSV format :
                    Planning Name;Start day;End Day
                    ex. Planning1;01/01;01/12
                    ">Planning1;01/01;01/12</b-input>
                </b-field>

                <b-field :label="$t('ImportPlanningModal.input_routes')">
                    <b-input v-model="routesData" type="textarea" rows="5" placeholder="CSV format :
                    Route name;Tags;Vehicule Registration; Departure Time (24h format); Estimated come back time; Driver Name
                    ex. Run 1.1;tags1,tags2;17:12;20:00;Harry Cover
                    Vehicule registration need to match with existing one."></b-input>
                </b-field>

                <b-field :label="$t('ImportPlanningModal.input_pod')">
                    <b-input v-model="podData" type="textarea" rows="5" placeholder="CSV format :
                    Run Name;Site Code;Deliver on Monday;Tuesday;Wednesday;Thursday;Friday;Saturday;Sunday;Sequence
                    ex. Run 1.1;SiteCode;TRUE;FALSE;FALSE;TRUE;TRUE;TRUE;TRUE;1
                    Vehicule registration need to match with existing one.">Run 1.1;1315;TRUE;FALSE;TRUE;TRUE;FALSE;TRUE;TRUE</b-input>
                </b-field>

                <b-field :label="$t('ImportPlanningModal.input_vehicles')">
                    <b-input v-model="vehiclesData" type="textarea" rows="5" placeholder="CSV format :
                    Vehicule Registration;Trolley Capacity; Weight Capacity(kg); Comment
                    ex. AP-888-78;23;3000;Truck Key are in the box at the entrance"></b-input>
                </b-field>
            </b-tab-item>

            <b-tab-item label="Import Report" :visible="showReport" ref="report">
                <template slot="header">
                    <b-icon icon="information-outline"></b-icon>
                    <span> {{$t('ImportPlanningModal.tab_status')}} </span>
                </template>

                <b-field :label="$t('ImportPlanningModal.input_status')">
                    <b-input v-model="report" type="textarea" rows="20" placeholder=""></b-input>
                </b-field>
            </b-tab-item>

        </b-tabs>

    </section>
    <footer class="card-footer">
        <div class="card-footer-item">
            <button class="button is-primary" @click="save()">{{$t('ImportPlanningModal.action_import')}}</button>
        </div>
    </footer>
</div>
</template>

<script>
export default {
  name: 'ImportPlanningModal',
  data: function () {
    return {
      showReport: false,
      jsonData: '',
      planningData: 'Planning1;01/01;01/12',
      routesData: 'Run 1.1;tags1,tags2;vehicle1;17:12;20:00;Harry Cover',
      podData: 'Run 1.1;1315;TRUE;FALSE;TRUE;TRUE;TRUE;TRUE;TRUE;0',
      vehiclesData: 'vehicle1;23;3000;Truck Key are in the box at the entrance',
      report: ''
    }
  },

  methods: {
    save: function () {
      const importedData = {}
      importedData.planning = this.planningData
      importedData.routes = this.routesData
      importedData.pod = this.podData
      importedData.vehicles = this.vehiclesData
      this.$store.dispatch('planning/importCSVPlanning', importedData)
        .then(response => {
          this.report = response.data
          this.showReport = true
        })
    }
  }
}
</script>

<style>
.card-header {
    background-color: #448993;
}

.modal-content {
    overflow: unset !important;
}

.modal-card-header-title {
    border-radius: 3px 3px 0px 0px !important;
}

.modal-card-title {
    color: white !important;
    font-size: 20px !important;
    font-weight: initial !important;
}

.modal-card {
    width: auto;
    border-radius: 3px !important;
}

.modal .modal-content {
    width: 640px;
}
</style>
